import { render, staticRenderFns } from "./PredictionsCombinedList.vue?vue&type=template&id=79377132&"
import script from "./PredictionsCombinedList.vue?vue&type=script&lang=js&"
export * from "./PredictionsCombinedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports